<section class="page-back">
  <!-- start banner Area -->
  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 80px 0px 80px 0px !important;"> Accueil Administrateur</h1>

          </div>
        </div>
      </div>
    </div>
  </section>
  <br> <br>
  <!-- End banner Area -->

  <!-- Start service Area -->
  <div class="container">
    <div class="row">
      <div class="col-lg-12 mb-5">
        <div class="card">
          <div class="card-body">
            <div class="main_counter_area">
              <div class="overlay ">
                <div class="container">
                  <div class="">
                    <div class="row main_counter_content text-center white-text wow fadeInUp mb-2">
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-book m-b-1"></i>
                          <a routerLink="/admin/publier-offre-emploi" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Publier un avis</h2>
                          </a>

                          <span></span>
                          <p></p>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-book m-b-1"></i>
                          <a routerLink="/admin/offres-emploi/0" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Toute les offres</h2>
                          </a>

                          <p></p>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-users m-b-1"></i>
                          <a routerLink="/tous-les-candidats" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">CV Thèque Candidats</h2>
                          </a>

                          <p></p>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-users m-b-1"></i>
                          <a routerLink="/tous-les-consultants" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Consultants</h2>
                          </a>

                          <p></p>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-building m-b-1"></i>
                          <a routerLink="/admin/entreprises" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Entreprise</h2>
                          </a>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-tasks m-b-1"></i>
                          <a routerLink="/admin/ajouter-entreprises" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Ajouter Une Entreprise</h2>
                          </a>

                          <p></p>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="single_counter p-y-2 m-t-1">
                          <i class="fa fa-users m-b-1"></i>
                          <a routerLink="/admin/administrateur" style="text-decoration: none;color:#00027D; ">
                            <h2 class="statistic-counter">Users</h2>
                          </a>

                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="row justify-content-center mb-4">
                    <a routerLink="/compte-candidat" target="_blank" class="customize-link1"> Améliorer</a>
                  </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mb-5">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body link-parent">
            <h3 style="color: ;" class="mt-2 mb-2">Ressources utiles</h3>
            <a routerLink="/admin/ajouter-entreprises" class="customize-link"> Ajouter une entreprise</a>
            <a routerLink="/admin/publier-offre-emploi" class="customize-link"> Publier une offre</a>
            <a routerLink="/admin/offres-emploi/0" class="customize-link"> Toutes les offres d'emploi</a>
            <a routerLink="/admin/entreprises" class="customize-link"> Toutes les entreprises</a>
            <a class="customize-link" routerLink="/tous-les-candidats">CV thèques candidats</a>
            <a routerLink="/tous-les-consultants" class="customize-link"> CV thèques
              consultants</a>
            <a class="customize-link" routerLink="/admin/administrateur">Enregister un
              utilisateur</a>

          </div>
        </div>
      </div>

    </div> -->
    <!-- <div class="row mt-2 mb-5">
      <div class="col-lg-6">
        <div class="card sauvegardes">
          <div class="card-body sauvegardes-child">
            <h3 style="color: #ff5a00;">Offres en attente</h3>
            <div class="col-lg-12 post-list" style="margin-left: -15px;">

            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card sauvegardes">
          <div class="card-body sauvegardes-child">
            <h3 style="color: #ff5a00;">Mes alertes d'emploi</h3>

            <div>
              
              <div class="row">
                <div class="card col-lg-6">
                  <div class="card-body">

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div> -->

  </div>
  <section class="service-area section-gap" id="service">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-md-12 pb-40 form-area">
          <div class="row text-center">
            <!-- <div class="col-lg-4 mb-3">
              <a routerLink="/admin/publier-offre-emploi" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">Publier une offre
                      d'emploi</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-4 mb-3">
              <a routerLink="/admin/offres-emploi/0" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">Toutes les offres d'emploi</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-4 mb-3">
              <a routerLink="/admin/entreprises" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">Toutes les entreprises</p>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-lg-4 mb-3">
              <a routerLink="/tous-les-candidats" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">CV thèques candidats</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-4 mb-3">
              <a routerLink="/tous-les-consultants" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">CV thèques
                      consultants</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-4 mb-3">
              <a routerLink="/admin/administrateur" class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">Enregister un
                      utilisateur</p>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-4 mb-3">
              <a class="menu-home">
                <div class="offre-list-card p-4">
                  <div class="details-offre">
                    <p class="poste-offre">Tous les forfaits</p>
                  </div>
                </div>
              </a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/admin/publier-offre-emploi"><button class="btn-portail-start">Publier une offre
                  d'emploi</button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/admin/offres-emploi/0"><button class="btn-portail-start">Toutes les offres
                  d'emploi</button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/admin/entreprises"><button class="btn-portail-start">Toutes les entreprises</button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/tous-les-candidats"><button class="btn-portail-start">CV thèques candidats</button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/tous-les-consultants"><button class="btn-portail-start"></button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a role="link" aria-disabled="true"><button class="btn-portail-start">Tous les forfaits</button></a>
            </div> -->
            <!-- <div class="col-lg-6 mb-4">
              <a routerLink="/admin/administrateur"><button class="btn-portail-start">Enregister un
                  utilisateur</button></a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End service Area -->

</section>